export default "__VITE_PUBLIC_ASSET__f540b05b__"